import { ObjectHelpers } from "../../helpers/object-helpers";
const color = require('../../library/darken-color.js');

export class ChartStyleColorModel {
    public r = 0;
    public g = 0;
    public b = 0;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }

    public toRGB(): string {
        return `rgb(${this.r}, ${this.g}, ${this.b})`;
    }

    /**
     * @param {number} value opacity, start from 0.0 - 1.0
     */
    public toRGBA(value: number): string {
        return `rgba(${this.r}, ${this.g}, ${this.b}, ${value})`;
    }

    public toHex(): string {
        return color.RGB2HEX(this.r, this.g, this.b);
    }

    /**
     * Make a color lighter, start from 0 - 100
     */
    public lighten(value: number): string {
        return color.lighten(this.toHex(), value);
    }

    /**
     * Make a color darker, start from 0 - 100
     */
    public darken(value: number): string {
        return color.darken(this.toHex(), value);
    }

    /**
     * Define if a color is dark and allow index customization .5 is center value but depending of context we can decide that we could consider 
     * a color is too dark for a certain component
     */
    public isDark(brightIndex?: number) {
        if (!brightIndex) {
            brightIndex = 0.5;
        }

        const brightness = this.getBrightness();
        return brightness <= brightIndex;
    }

    public getBrightness(): number {
        let num = this.r / 255;
        let num2 = this.g / 255;
        let num3 = this.b / 255;
        let num4 = num;
        let num5 = num;
        if (num2 > num4) {
            num4 = num2;
        }

        if (num3 > num4) {
            num4 = num3;
        }

        if (num2 < num5) {
            num5 = num2;
        }

        if (num3 < num5) {
            num5 = num3;
        }

        return (num4 + num5) / 2;
    }
}